/** @format */

import React, { useState, useEffect, useRef } from "react";

import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.js";
import "bootstrap-icons/font/bootstrap-icons.css";
import "../../css/PDPA.css";

export default function PDPA(props) {
  const [expand, setExpand] = useState(false);
  return (
    <div
      style={{
        backgroundColor: "rgb(238 238 238 / 62%)",
        marginTop: "2rem",
        marginBottom: "5rem",
        width: "fit-content",
        padding: "0.2rem 0.5rem",
      }}>
      <div
        style={{
          display: "flex",
          alignItems: "center",
        }}
        onClick={() => setExpand(!expand)}>
        {!expand ? (
          <svg
            class="w-6 h-6 text-gray-800 dark:text-white"
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            fill="none"
            viewBox="0 0 24 24">
            <path
              stroke="currentColor"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="m8 10 4 4 4-4"
            />
          </svg>
        ) : (
          <svg
            class="w-6 h-6 text-gray-800 dark:text-white"
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            fill="none"
            viewBox="0 0 24 24">
            <path
              stroke="currentColor"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="m16 14-4-4-4 4"
            />
          </svg>
        )}

        <p className="txt-txt title-pdpa" style={{ cursor: "pointer" }}>
          หนังสือให้ความยินยอมในการเก็บรวบรวม/ใช้/เปิดเผยข้อมูล
        </p>
      </div>

      {expand && (
        <div style={{ marginLeft: "0.5rem" }}>
          <p className="txt-txt sub-title-pdpa">
            Traffy Fondue สวทช.
            ให้ความสำคัญกับความเป็นส่วนตัวจึงขอความยินยอมเพื่อการเก็บรวบรวม ใช้
            และ/หรือเปิดเผยข้อมูล ที่ท่านให้ไว้หรือที่ได้รับมาจากแหล่งอื่น อาทิ
            เช่น ข้อความ รูปภาพ พิกัดตำแหน่งสำหรับวัตถุประสงค์ดังนี้
          </p>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              margin: "1rem 0",
              gap: "8px",
            }}>
            <p className="txt-txt sub-title-pdpa">
              1. เพื่อรวบรวมและนำส่งข้อมูลให้หน่วยงานที่เกี่ยวข้อง
              พิจารณาและแก้ไขปัญหาตามอำนาจและหน้าที่
            </p>
            <p className="txt-txt sub-title-pdpa">
              2. เพื่อใช้สำหรับพัฒนาระบบการให้บริการและเพื่อวิเคราะห์
              วิจัยของห้องปฏิบัติการ
            </p>
            <p className="txt-txt sub-title-pdpa">
              3.
              เพื่อแสดงผลข้อมูลโดยไม่ระบุตัวผู้แจ้งในหน้าเว็บไซต์สาธารณะซึ่งสามารถเข้าถึงได้โดยบุคคลทั่วไป
              ผู้ใช้งานมีสิทธิถอนความยินยอมที่ให้ไว้ทุกเมื่อ ที่ Line@ Traffy
              Fondue Help
            </p>
          </div>
          <p className="txt-txt sub-title-pdpa">
            ผู้ใช้งานมีสิทธิ์ในการถอนความยินยอมได้ตลอดเวลา ผ่านทาง Line@ Traffy
            Fondue Help
          </p>
        </div>
      )}
    </div>
  );
}
